// Кампанийные сцены-посадки: засеянные ЧЕСТНЫЕ (достижимые) состояния под рекламу.
// A — «почти-победа» (свайп до 2048); C — «партия в процессе» (продолжи хороший ран).
// Заголовок берётся из i18n по headlineKey. Проверять каждую сцену вручную через
// /cld2048/?scene=<id>: заявленный ход реально даёт 2048 и доска не запатована.
//
// URL объявления: /cld2048/?scene=<id>&utm_source=<net>&utm_campaign=<c>&utm_content=<creative>
// Для A/B в объявлении меняем только scene и utm_content.

type HeadlineKey = 'hook_2048_nearwin' | 'hook_2048_almost' | 'hook_2048_midgame';

export interface Scene {
  tiles: Array<{ value: number; row: number; col: number }>;
  score: number;
  headlineKey: HeadlineKey;
}

export const SCENES: Record<string, Scene> = {
  // A: два 1024 в нижнем ряду — свайп влево/вправо сливает их в 2048.
  'nearwin-a': {
    headlineKey: 'hook_2048_nearwin',
    score: 20140,
    tiles: [
      { value: 2, row: 0, col: 0 }, { value: 4, row: 0, col: 1 }, { value: 8, row: 0, col: 2 }, { value: 16, row: 0, col: 3 },
      { value: 64, row: 1, col: 0 }, { value: 128, row: 1, col: 1 }, { value: 256, row: 1, col: 2 }, { value: 512, row: 1, col: 3 },
      { value: 32, row: 2, col: 0 }, { value: 2, row: 2, col: 3 },
      { value: 1024, row: 3, col: 0 }, { value: 1024, row: 3, col: 1 },
    ],
  },

  // A: два 1024 в левом столбце — свайп вверх сливает их в 2048.
  'almost-b': {
    headlineKey: 'hook_2048_almost',
    score: 19680,
    tiles: [
      { value: 1024, row: 0, col: 0 }, { value: 2, row: 0, col: 1 }, { value: 4, row: 0, col: 2 }, { value: 8, row: 0, col: 3 },
      { value: 1024, row: 1, col: 0 }, { value: 16, row: 1, col: 1 }, { value: 32, row: 1, col: 2 }, { value: 64, row: 1, col: 3 },
      { value: 128, row: 2, col: 1 }, { value: 256, row: 2, col: 2 }, { value: 512, row: 2, col: 3 },
      { value: 8, row: 3, col: 1 }, { value: 4, row: 3, col: 2 }, { value: 2, row: 3, col: 3 },
    ],
  },

  // C: развитая, играбельная доска (макс. 512, есть пустые клетки и ходы) — не
  // мгновенная победа, а ощущение «продолжи набранный ран».
  'midgame-c': {
    headlineKey: 'hook_2048_midgame',
    score: 7120,
    tiles: [
      { value: 8, row: 0, col: 0 }, { value: 32, row: 0, col: 1 }, { value: 4, row: 0, col: 2 }, { value: 2, row: 0, col: 3 },
      { value: 64, row: 1, col: 0 }, { value: 128, row: 1, col: 1 }, { value: 16, row: 1, col: 2 },
      { value: 256, row: 2, col: 0 }, { value: 512, row: 2, col: 1 }, { value: 4, row: 2, col: 2 },
      { value: 2, row: 3, col: 0 },
    ],
  },
};
